/**
 * Deduplicate concurrent identical API calls (Strict Mode remounts, multi-hook mounts).
 * Same key shares one in-flight Promise; optional short TTL keeps a completed result.
 */

const inflight = new Map();
const recent = new Map();

export function dedupeRequest(key, factory, ttlMs = 2000) {
  const k = String(key);
  const cached = recent.get(k);
  if (cached && Date.now() - cached.at < ttlMs) {
    return Promise.resolve(cached.value);
  }
  if (inflight.has(k)) {
    return inflight.get(k);
  }
  const promise = Promise.resolve()
    .then(factory)
    .then((value) => {
      recent.set(k, { at: Date.now(), value });
      return value;
    })
    .finally(() => {
      inflight.delete(k);
    });
  inflight.set(k, promise);
  return promise;
}
